module.exports = __webpack_public_path__ + "static/Untitled-1-04-34cdbd76689ee41accd290ded72ed972.jpg";